// extracted by mini-css-extract-plugin
export default {"container":"GDwlz","submission":"Ji_iu","price":"S3Yf2","priceValue":"Dm_GR","disabledTextBar":"ps8TB","input":"fH_Ep"};